<template>
  <div>
    <div style="width: 100%" class="yxzcsr">
      <!-- <div class="tzgg" @click="updateTable('金融服务')">
        <div class="title">
          <span>金融服务</span>
          <router-link to="/financialService">
            <span>更多</span>
            <img src="@/assets/img/more_white.png" alt="" />
          </router-link>
        </div>
      </div>
      <div class="cjgg" @click="updateTable('保险产品')">
        <div class="title">
          <span>保险产品</span>
          <router-link to="">
            <span>更多</span>
            <img src="@/assets/img/more_white.png" alt="" />
          </router-link>
        </div>
      </div>
      <div class="jzgg" @click="updateTable('便民服务')">
        <div class="title">
          <span>便民服务</span>
          <router-link to="">
            <span>更多</span>
            <img src="@/assets/img/more_white.png" alt="" />
          </router-link>
        </div>
      </div> -->
    </div>
    <div>
      <!-- <el-table
        v-if="tableType === '金融服务'"
        header-row-class-name="tableHeader"
        :data="list0"
        style="width: 100%; min-height: 500px">
        <el-table-column width="400" align="center" prop="cid" label="登记编号">
        </el-table-column>
        <el-table-column
          width="400"
          align="center"
          prop="address"
          label="融资地区">
        </el-table-column>
        <el-table-column
          width="200"
          align="center"
          prop="dyname"
          label="抵押申请人">
        </el-table-column>
        <el-table-column
          width="200"
          align="center"
          prop="type"
          label="抵押物类型">
        </el-table-column>
        <el-table-column
          width="300"
          align="right"
          header-align="center"
          prop="amount"
          label="贷款金额(元)">
          <template slot-scope="scope">
            {{ Number(scope.row.amount).toFixed(2) }}
          </template>
        </el-table-column>
        <el-table-column align="center" prop="registertime" label="登记时间">
        </el-table-column>
      </el-table> -->
      <div>
        <!--  v-if="tableType === '金融服务'" -->
        <!-- <div
          style="
            display: flex;
            align-items: center;
            padding: 0 10px;
            font-size: 20px;
            font-size: 20px;
            margin: 10px 0px;
          "
        >
          <div
            style="
              display: flex;
              align-items: center;
              flex: 1;
              justify-content: space-between;
            "
          >
            <div style="display: flex; align-items: center">
              <span>贷款额度</span>
              <div class="select" @click="showDKEDList = !showDKEDList">
                <span
                  class="placeholder"
                  :style="reqPayload.DKED ? {} : { color: '#ccc' }"
                  >{{
                    reqPayload.DKED == "" ? "请选择贷款额度" : reqPayload.DKED
                  }}</span
                >
                <div :style="showDKEDList ? {} : { display: 'none' }">
                  <span
                    @click="checkDKED(DKED.text)"
                    class="native"
                    v-for="(DKED, index) in DKEDList"
                    :key="index"
                    >{{ DKED.text }}</span
                  >
                </div>
              </div>
            </div>
            <div style="display: flex; align-items: center">
              <span>贷款期限</span>
              <div class="select" @click="showDKQXList = !showDKQXList">
                <span
                  class="placeholder"
                  :style="reqPayload.DKQX ? {} : { color: '#ccc' }"
                  >{{
                    reqPayload.DKQX == "" ? "请选择贷款期限" : reqPayload.DKQX
                  }}</span
                >
                <div :style="showDKQXList ? {} : { display: 'none' }">
                  <span
                    @click="checkDKQX(DKQX.text)"
                    class="native"
                    v-for="(DKQX, index) in DKQXList"
                    :key="index"
                    >{{ DKQX.text }}</span
                  >
                </div>
              </div>
            </div>
            <div style="display: flex; align-items: center">
              <span>贷款类型</span>
              <div class="select" @click="showDKLXList = !showDKLXList">
                <span
                  class="placeholder"
                  :style="reqPayload.DKLX ? {} : { color: '#ccc' }"
                  >{{
                    reqPayload.DKLX == "" ? "请选择贷款类型" : reqPayload.DKLX
                  }}</span
                >
                <div :style="showDKLXList ? {} : { display: 'none' }">
                  <span
                    @click="checkDKLX(DKLX.text)"
                    class="native"
                    v-for="(DKLX, index) in DKLXList"
                    :key="index"
                    >{{ DKLX.text }}</span
                  >
                </div>
              </div>
            </div>
          </div>

          <el-button type="primary" size="medium">查看匹配产品</el-button>
        </div>
        <div class="jrfwList">
          <div v-for="(jr, index) in jrcpList" :key="index">
            <div class="image">
              <img :src="jr.img" alt="" />
            </div>
            <div class="detail">
              <span class="name">{{ jr.name }}</span>
              <div>
                <div class="rate">
                  <span>{{ jr.rate }}</span>
                  <span>参考利率（年化）</span>
                </div>
                <div class="date">
                  <span>{{ jr.date }}</span>
                  <span>贷款期限</span>
                </div>
                <div class="limit">
                  <span>{{ jr.limit }}</span>
                  <span>贷款额度</span>
                </div>
                <div class="guarantee">
                  <span>{{ jr.guarantee }}</span>
                  <span>担保方式</span>
                </div>
              </div>
            </div>
            <div class="content">
              <div class="button">查看详情</div>
              <span
                >成功对接需求笔数<span>{{ jr.count }}</span
                >笔</span
              >
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import {
  getNewslist,
  publicityList,
  attest,
  desiredList,
} from '../../../api/mian'
import request from '@/util/request'
import { financingMsgList } from '@/api/金融服务'
export default {
  data () {
    return {
      dm: '',
      area_name: '',
      li_id: 0,
      list0: [],
      list1: [],
      list2: [],
      list3: [],
      list4: [],
      tableType: '金融服务',
      showDKEDList: false,
      DKEDList: [
        {
          text: '小于一万',
        },
        {
          text: '1万-10万',
        },
        {
          text: '10万-20万',
        },
        {
          text: '20万-30万',
        },
        {
          text: '大于30万',
        },
      ],
      showDKQXList: false,
      DKQXList: [
        {
          text: '3个月及以下',
        },
        {
          text: '6个月及以下',
        },
        {
          text: '12个月及以下',
        },
        {
          text: '24个月及以下',
        },
        {
          text: '36个月及以下',
        },
      ],
      showDKLXList: false,
      DKLXList: [
        {
          text: '信用贷款',
        },
        {
          text: '担保贷款',
        },
        {
          text: '抵押贷款',
        },
        {
          text: '保证贷款',
        },
        {
          text: '质押贷款',
        },
      ],
      reqPayload: {
        DKED: '',
        DKQX: '',
        DKLX: '',
      },
      jrcpList: [
        {
          img: require('../../../assets/img/jrcp1.webp'),
          name: '中国工商银行股份有限公司上蔡支行',
          rate: '4.35-6.52%',
          date: '1-12个月',
          limit: '1-500万',
          guarantee: '不限',
          count: '468',
        },
        /**
        {
          img: require('../../../assets/img/jrcp1.webp'),
          name: '工商银行',
          rate: '4.35-6.52%',
          date: '1-12个月',
          limit: '1-500万',
          guarantee: '不限',
          count: '468',
        },
        {
          img: require('../../../assets/img/jrcp2.webp'),
          name: '民生银行',
          rate: '3.00-4.05%',
          date: '12-12个月',
          limit: '100-1,000万',
          guarantee: '不限',
          count: '405',
        },
        */
      ],
    }
  },
  created () {
    this.dm = this.$route.query.dm
    this.area_name = this.$route.query.area_name
    window.addEventListener('click', (e) => {
      if (
        !(
          e.target.className == 'native' ||
          e.target.className == 'select' ||
          e.target.className == 'placeholder'
        )
      ) {
        this.showDKEDList = false
        this.showDKQXList = false
        this.showDKLXList = false
      }
    })
    // 通知公告数据

    // let data1 = {
    //   number: '004',
    //   pageNum: 1,
    //   pageSize: 7,
    // }
    // getNewslist(data1).then((res) => {
    //   this.list0 = res.data.rows
    // })
    financingMsgList({
      pageNum: 1,
      pageSize: 7,
    }).then((res) => {
      this.list0 = res.data.rows
    })

    // 成交公告数据
    // let data2 = {
    //   number: '004',
    //   pageNum: 1,
    //   pageSize: 7,
    // }
    // publicityList(data2).then((res) => {
    //   this.list1 = res.data.rows
    // })

    // 鉴证公告数据
    attest({
      pageNum: 1,
      pageSize: 7,
    }).then((res) => {
      this.list2 = res.data.rows
      // console.log('鉴证公告', res)
    })

    desiredList({
      type: 1,
      pageNum: 1,
      pageSize: 7,
    }).then((res) => {
      console.log('意向转出', res)
      this.list3 = res.data.rows
    })

    desiredList({
      type: 2,
      pageNum: 1,
      pageSize: 7,
    }).then((res) => {
      console.log('意向受让', res)
      this.list4 = res.data.rows
    })
  },
  methods: {
    checkDKLX (text) {
      this.reqPayload.DKLX = text
    },
    checkDKQX (text) {
      this.reqPayload.DKQX = text
    },
    checkDKED (text) {
      this.reqPayload.DKED = text
    },
    updateTable (type) {
      this.tableType = type
    },
    changeBJ (e) {
      this.li_id = e
    },
  },
}
</script>

<style scoped>
.jrfwList {
  display: flex;
  flex-direction: column;
  min-height: 300px;
}
.jrfwList > div {
  width: 100%;
  display: flex;
  align-items: center;
  border-top: 1px solid #ddd;
  margin-bottom: 10px;
  padding: 10px 0px;
  box-sizing: border-box;
}
.jrfwList > div > .image {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  margin-right: 50px;
  padding-right: 30px;
  border-right: 1px solid #ddd;
  box-sizing: border-box;
}
.jrfwList > div > .image > img {
  display: block;
  width: 220px;
}
.jrfwList > div > .detail {
  display: flex;
  flex-direction: column;
  flex: 1;
  margin-right: 50px;
}
.jrfwList > div > .detail > .name {
  font-size: 26px;
  font-weight: bold;
  margin-bottom: 14px;
}
.jrfwList > div > .detail > div {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
}
.jrfwList > div > .detail > div > div {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.jrfwList > div > .detail > div > div > span {
  font-size: 20px;
}
.jrfwList > div > .detail > div > div > span:first-child {
  margin-bottom: 10px;
}
.jrfwList > div > .detail > div > .rate > span:first-child {
  font-size: 26px;
  color: #2187ff;
}
.jrfwList > div > .detail > div > .date > span:first-child {
  font-size: 26px;
}
.jrfwList > div > .detail > div > .limit > span:first-child {
  font-size: 26px;
}
.jrfwList > div > .content {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.jrfwList > div > .content > .button {
  padding: 14px 56px;
  background-color: #2187ff;
  color: #fff;
  border-radius: 6px;
  font-size: 20px;
  cursor: pointer;
  margin-bottom: 36px;
}
.jrfwList > div > .content > span {
  font-size: 18px;
}
.jrfwList > div > .content > span > span {
  font-weight: bold;
}
.yxzcsr {
  width: 100%;
  height: auto;
  display: flex;
  justify-content: space-between;
}
.yxzcsr > div {
  height: 94px;
  width: 558px;
}
.yxzcsr > .tzgg {
  background: url("../../../assets/img/tzgg.png") no-repeat;
  background-size: 100% 100%;
}
.yxzcsr > .cjgg {
  background: url("../../../assets/img/cjgg.png") no-repeat;
  background-size: 100% 100%;
}
.yxzcsr > .jzgg {
  background: url("../../../assets/img/jzgg.png") no-repeat;
  background-size: 100% 100%;
}
.yxzcsr > * > .title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  padding: 0 23px 0 44px;
}
.yxzcsr > * > .title > span {
  font-family: SourceHanSans-Bold;
  font-size: 24px;
  color: #ffffff;
  text-align: center;
  font-weight: bold;
}
.yxzcsr > * > .title > a {
  display: flex;
  align-items: center;
}
.yxzcsr > * > .title > a > span {
  font-family: SourceHanSans-Regular;
  font-size: 18px;
  color: #ffffff;
  text-align: right;
  font-weight: 400;
}
.yxzcsr > * > .title > a > img {
  width: 10px;
  height: 10px;
}
.yxzcsr > * > .dataList {
  height: 300px;
  width: 100%;
}
.yxzcsr > * > .dataList > div > a {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0;
}
.yxzcsr > * > .dataList > div:first-child > a {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0;
  padding-top: 26px;
}
.yxzcsr > * > .dataList > div > a > span {
  font-size: 18px;
  display: flex;
  align-items: center;
}
.yxzcsr > * > .dataList > div > a > span:first-child > span {
  width: 400px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.yxzcsr > * > .dataList > div > a > span:first-child > img {
  width: 10px;
  height: 16px;
  margin-right: 10px;
}
.select {
  border: 2px solid #ddd;
  position: relative;
  width: 250px;
  height: 40px;
  margin: 0 10px;
  display: flex;
  align-items: center;
  padding: 0px 8px;
  font-size: 16px;
  cursor: pointer;
}
.select > div {
  position: absolute;
  top: 100%;
  left: 0;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  font-size: 16px;
  width: 100%;
  z-index: 99;
  box-sizing: border-box;
  border: 1px solid #ddd;
  border-radius: 6px;
  max-height: 260px;
  overflow: auto;
}
.select > div > span {
  padding: 8px;
}
.select > div > span:hover {
  background-color: #ddd;
  cursor: pointer;
}
</style>
